// ─────────────────────────────────────────────────────────────────
// Glass-i — ErpMasterShell
//
// Standard viewport-fit wrapper for ERP master pages. Cancels the
// outer AppLayout `py-6` padding, stretches the inner card to the
// full viewport height below the topbar, and propagates a
// `flex flex-col` context so <ErpDataGrid /> can pin its toolbar +
// header at the top and its pagination footer at the bottom.
//
// Usage:
//
//   const { gridHandlers, ApprovalMfaModalSlot } = useErpMaster({ ... });
//
//   return (
//     <ErpMasterShell modalSlot={ApprovalMfaModalSlot}>
//       <ErpDataGrid {...gridHandlers} ... />
//     </ErpMasterShell>
//   );
//
// Anything passed to `modalSlot` renders after the card — useful for
// the Approval MFA modal slot or any page-level overlay. Pass `null`
// to omit.
// ─────────────────────────────────────────────────────────────────

export default function ErpMasterShell({ children, modalSlot = null }) {
  // Stage UI-POLISH-LAYOUT-01:
  //   - `rounded-lg` + a 1-px subtle shadow lift the white card from
  //     the slate-blue page background so it reads as a discrete
  //     surface (Linear / Stripe feel) rather than an edge-to-edge fill.
  //   - We deliberately do NOT add `overflow-hidden` here: ErpDataGrid
  //     relies on its own internal sticky toolbar / header / pagination,
  //     and an overflow-clip at this level would create a new block
  //     formatting context that risks breaking those sticky anchors.
  //   - `-my-6` is preserved so viewport-fit grids keep working.
  return (
    <div className="-my-6 min-h-[calc(100vh-64px)] flex flex-col">
      <div className="bg-white border border-surface-200 rounded-lg shadow-[0_1px_2px_rgba(15,23,42,0.04)] flex-1 flex flex-col min-h-0">
        {children}
      </div>
      {modalSlot}
    </div>
  );
}
